import { render, staticRenderFns } from "./_basicSet.vue?vue&type=template&id=f07e1f5e"
import script from "./_basicSet.vue?vue&type=script&lang=js"
export * from "./_basicSet.vue?vue&type=script&lang=js"
import style0 from "./_basicSet.vue?vue&type=style&index=0&id=f07e1f5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports